module.exports = __webpack_public_path__ + "static/media/arrow-left.47235d44.svg";